import React, { FC, memo } from 'react';

import Content from '../../components/content';
import Button from '../../components/button';

import './start.scss';
import Logo from './logo.svg';

interface StartProps {
  onClick: () => void,
}

const Start: FC<StartProps> = memo(({ onClick }) => {
  return (
    <div className="start">
      <Content className="-blue">
        <div className="start__logo"><img src={Logo} alt="mail.ru" /></div>
        <h1 className="start__title">
          <span>Тест-игра</span>
          Помогите детям <br />не&nbsp;попасться в&nbsp;сети
        </h1>
        <p className="start__text">
          От&nbsp;кибербуллинга до&nbsp;фишинга&nbsp;&mdash; в&nbsp;интернете детей на&nbsp;каждом шагу подстерегают опасности. Сможете&nbsp;ли вы&nbsp;сами справиться с&nbsp;ними и&nbsp;оградить ребёнка? Проверьте в&nbsp;нашей игре ко&nbsp;
          <b>Дню защиты детей!</b>
        </p>
        <Button onClick={onClick}>Начать игру</Button>
      </Content>
	  </div>
  );
});

export default Start;
